import { useMutation } from '@tanstack/react-query'

import { deleteMerchantGeneralBlockList } from '@src/api'
import { DefaultApiDeleteMerchantGeneralBlockListRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteMerchantGeneralBlockList = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDeleteMerchantGeneralBlockListRequest) =>
      deleteMerchantGeneralBlockList(axiosInstance, params),
  })
}
